import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProfilesLayoutComponent } from 'src/app/feature/layout/profiles-layout/profiles-layout.component';

import { LocaleResolve } from './core/locale/locale.resolve';
import { GuestLayoutComponent } from './feature/layout/guest-layout/guest-layout.component';
import { LayoutComponent } from './feature/layout/layout.component';
import { LoginLayoutComponent } from './feature/layout/login-layout/login-layout.component';
import { RecoverComponent } from './pages/recover/recover.component';

export const NotFoundRoute = {
	path: '**',
	redirectTo: 'login',
};

const routes: Routes = [
	{
		path: '',
		component: LayoutComponent,
		children: [
			{
				path: ':tenantName/:merchantId',
				children: [
					{
						path: ':language',
						children: [
							{
								path: '',
								redirectTo: 'login',
								pathMatch: 'full',
							},
							{
								path: 'auto-login',
								loadChildren: () =>
									import('./pages/auto-login/auto-login.module').then((mod) => mod.AutoLoginModule),
							},
							{
								path: '',
								component: LoginLayoutComponent,
								children: [
									{
										path: 'login',
										loadChildren: () =>
											import('./pages/login/login.module').then((mod) => mod.LoginModule),
									},
									{
										path: 'accesso-login',
										loadChildren: () =>
											import('./pages/accesso-id-login/accesso-id-login.module').then(
												(mod) => mod.AccessoIdLoginModule
											),
									},
									{
										path: 'recover',
										component: RecoverComponent,
										data: {
											locales: ['recover'],
										},
										resolve: [LocaleResolve],
									},
									{
										path: 'verify',
										loadChildren: () =>
											import('../app/pages/verify/verify.module').then((mod) => mod.VerifyModule),
									},
									{
										path: 'orders',
										loadChildren: () =>
											import('../app/pages/orders/orders.module').then((mod) => mod.OrdersModule),
									},
								],
							},
							{
								path: '',
								component: GuestLayoutComponent,
								children: [
									{
										path: 'account',
										loadChildren: () =>
											import('./pages/account/account.module').then((mod) => mod.AccountModule),
									},
									{
										path: 'booking-portal',
										loadChildren: () =>
											import('./pages/booking-portal/booking-portal.module').then(
												(mod) => mod.BookingPortalModule
											),
									},
								],
							},
							{
								path: '',
								component: ProfilesLayoutComponent,
								children: [
									{
										path: 'dashboard',
										loadChildren: () =>
											import('./pages/profile-overview/profile-overview.module').then(
												(mod) => mod.ProfileOverviewModule
											),
									},
								],
							},
							{ ...NotFoundRoute },
						],
					},
				],
			},
			{
				path: 'invalid',
				loadChildren: () => import('./pages/invalid/invalid.module').then((mod) => mod.InvalidModule),
			},
			{
				path: 'not-found',
				loadChildren: () => import('./pages/not-found/not-found.module').then((mod) => mod.NotFoundModule),
			},
			{ ...NotFoundRoute },
		],
	},
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule],
})
export class AppRoutingModule {}
